import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { MortgageApplicationService } from '../../services/mortgage-application.service';
import { TabNavigationService } from '../../services/tab-navigation.service';
import { BaseMortgageApplicationComponent } from '../base-mortgage-application.component';
import { MortgageApplicationNavigationEvents } from './../../../../lib/constants/mortgage-application-navigation-events';
import { Applicant } from './../../models/applicant.model';
import { MortgageApplicationStore } from './../../services/mortgage-application-store';

@Component({
  selector: 'boi-applicant',
  templateUrl: './applicant.page.html',
  styleUrls: ['./applicant.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicantPage extends BaseMortgageApplicationComponent {
  public currentApplicant: Applicant;
  public currentApplicantIndex: number;
  public deleteApplicantDialogOpened: boolean;

  constructor(
    protected readonly mortgageApplicationService: MortgageApplicationService,
    protected mortgageApplicationStore: MortgageApplicationStore,
    private readonly tabNavigationService: TabNavigationService,
    private readonly activeRoute: ActivatedRoute,
    private readonly router: Router,
    public changeDetectorRef: ChangeDetectorRef
  ) {
    super(mortgageApplicationStore);
  }

  protected initialize(): void {
    this.activeRoute.params.pipe(takeUntil(this.destroySubject$)).subscribe((params) => {
      this.currentApplicantIndex = this.extractApplicantIndexFromRouteParams(params);
      this.currentApplicant = this.mortgageApplication.Applicants[this.currentApplicantIndex];
    });
  }

  public addApplicant(): void {
    this.tabNavigationService.emitEvent({
      type: MortgageApplicationNavigationEvents.AddApplicant
    });
  }

  public deleteApplicant(): void {
    this.tabNavigationService.emitEvent({
      type: MortgageApplicationNavigationEvents.DeleteApplicant,
      data: this.currentApplicantIndex
    });
  }

  private extractApplicantIndexFromRouteParams(params: Params): number {
    const paramsApplicantIndex = +params['applicantId'];
    if (paramsApplicantIndex < this.mortgageApplication.Applicants.length) {
      return paramsApplicantIndex;
    }
    const actualApplicantIndex = this.mortgageApplication.Applicants.length - 1;
    void this.router.navigate(['..', actualApplicantIndex], { relativeTo: this.activeRoute, replaceUrl: true });

    return actualApplicantIndex;
  }
}
